import React from "react";

function Footer() {
  return (
    <footer className="bg-blue-500 w-full py-3 text-white text-center">
      <p>
        &copy; 2024 piTube by{" "}
        @khil😎
      </p>
    </footer>
  );
}

export default Footer;